import type {
  AccountTierFeatureCatalog,
  AccountTierKey,
  AccountTierLimitCatalog,
} from '@common/types';

export const ACCOUNT_TIER_ORDER: ReadonlyArray<AccountTierKey> = ['lite', 'core', 'pro'];

export const TIER_FEATURE_CATALOG: AccountTierFeatureCatalog = [
  {
    key: 'engagement',
    label: 'Guest Engagement',
    icon: 'groups',
    features: [
      { key: 'guests', label: 'Guest Management' },
      { key: 'reviews', label: 'Reviews' },
      { key: 'communications', label: 'Communications' },
      { key: 'email-alerts', label: 'Instant Alerts & Monthly Reports' },
    ],
  },
  {
    key: 'operations',
    label: 'Operations',
    icon: 'confirmation_number',
    features: [
      { key: 'service-tickets', label: 'Service Tickets' },
      { key: 'departments', label: 'Departments' },
      { key: 'milestones', label: 'Milestones' },
    ],
  },
  {
    key: 'intelligence',
    label: 'Intelligence',
    icon: 'query_stats',
    features: [
      { key: 'reports', label: 'Reports' },
      { key: 'sentiment', label: 'Sentiment Analysis' },
      { key: 'ai-analytics', label: 'AI Analytics' },
      { key: 'custom-dashboards', label: 'Custom Dashboards' },
    ],
  },
  {
    key: 'reach',
    label: 'Reach',
    icon: 'share',
    features: [
      { key: 'social-sharing', label: 'Social Sharing' },
      { key: 'social-monitoring', label: 'Social Monitoring' },
    ],
  },
];

export const TIER_LIMIT_CATALOG: AccountTierLimitCatalog = [
  { key: 'seats', label: 'User Seats', unit: 'users', metered: true },
  { key: 'monthly-reviews', label: 'Monthly Reviews', unit: 'reviews / mo', metered: true },
  { key: 'ai-credits', label: 'AI Credits', unit: 'credits / mo', metered: true },
  { key: 'connected-sources', label: 'Connected Sources', unit: 'sources', metered: true },
  { key: 'data-retention', label: 'Data Retention', unit: 'months' },
];

/** The tier feature that unlocks instant review emails and the monthly report. */
export const INSTANT_ALERTS_FEATURE = 'email-alerts';
